const product = {
  /**登录接口**/
  loginUrl: 'https://sso.eassist.me/applicant/login',
  /**申请账号接口**/
  applyUrl: '/applicant/apply',
  updateApplyUrl: '/applicant',
  applyInfo: '/applicant',
  /**重置密码接口**/
  passwordResetUrl: '/applicant/password-reset',
  /**上传文件接口**/
  uploadUrl: '/upload',
  serviceUrl: '/applicant/service-test',
  gradeUrl: '/applicant/service-test/grade',
  serviceTestUrl: '/applicant/service-test',
  dentalbillingUrl: '/applicant/dental-billing-test',
  colorTestUrl: '/applicant/color-test',
  hollandTestUrl: '/applicant/holland-test',
  selectApplyUrl: '/applicant/apply/switch',
  testBoardUrl: '/applicant/whatif',
  resiliencyBoardUrl: '/applicant/resiliency',
  abilityBoardUrl: '/applicant/resiliency/ability',
  loginToken:'/oauth2/userInfo2',
}
export { product }